<template>
    <div class="job-outlook-container">
        <el-row style="align-items: stretch;">
            <el-col :span="24" class="outlook-category">
                <div class="centered-content">
                    <img class="dropdown" style="width: 40%;" :src="outlookIcon" :alt="outlookAltDescription" />
                    <p class="outlook-description" v-html="outlookDescription"></p>
                </div>

            </el-col>
        </el-row>
        <div class="outlook-chart">
            <el-row :justify="'center'" :align="'middle'">
                <el-col :span="24" class="centered-content">
                    <el-tooltip :content="averageTooltip" placement="top">
                        <p class="data-average" style="line-height: 0;">{{ average }}</p>
                    </el-tooltip>
                </el-col>
            </el-row>
            <el-row :justify="'center'" :align="'middle'">
                <el-col :span="24">
                    <div class="centered-content">
                        <img class="dropdown" style="width: 95%;" :src="salaryChartImage" alt="Job outlook chart." />
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <!-- Left side content goes here -->
                    <el-tooltip :content="belowAverageTooltip" placement="top">
                        <p class="centered-content data-below-average" style="line-height: 0;">{{ belowAverage }}</p>
                    </el-tooltip>
                </el-col>

                <el-col :span="6" :offset="12">
                    <!-- Right side content goes here -->
                    <el-tooltip :content="aboveAverageTooltip" placement="top">
                        <p class="centered-content data-above-average" style="line-height: 0;">{{ aboveAverage }}</p>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import salaryChartImage from '@/assets/img/joboutlook/salary_chart.svg';
import belowAverageImage from '@/assets/img/joboutlook/outlook_below.png';
import averageImage from '@/assets/img/joboutlook/outlook_average.png';
import aboveAverageImage from '@/assets/img/joboutlook/outlook_bright.png';

export default {
    props: {
        jobOutlook: {
            type: Object,
        }
    },
    async created() {
        this.$store.dispatch(`organisation/getExchangeRates`).then(exchangeRateData => {
            const selectedCurrency =
                this.$i18n.messages[localStorage.getItem("locale") || "en-US"];

            this.exchangeRate =
                exchangeRateData?.find(
                    (r) => r.base == "USD"
                )?.rates[selectedCurrency.currency];

            this.currencySymbol = selectedCurrency.currency === "USD" ? "$" : "£";
        })
    },
    data() {
        return {
            exchangeRate: 1,
            currencySymbol: '',
            salaryChartImage,
            belowAverageImage,
            averageImage,
            aboveAverageImage
        }
    },
    computed: {
        average() {
            return `${this.currencySymbol}${(
                (this.jobOutlook?.salary.annual_median) * this.exchangeRate
            ).toLocaleString("en-US")}`;
        },
        averageTooltip() {
            return `Workers on average earn ${this.average}`;
        },
        belowAverageTooltip() {
            return `10% of workers earn ${this.belowAverage} or less`;
        },
        aboveAverageTooltip() {
            return `10% of workers earn ${this.aboveAverage} or more`;
        },
        belowAverage() {
            return `${this.currencySymbol}${(
                (this.jobOutlook?.salary?.annual_10th_percentile) * this.exchangeRate
            ).toLocaleString("en-US")}`;
        },
        aboveAverage() {
            const amount = this.jobOutlook?.salary?.annual_90th_percentile || 0;
            return `${this.currencySymbol}${(
                (amount) * this.exchangeRate
            ).toLocaleString("en-US")}`;
        },
        outlookIcon() {
            if (this.jobOutlook.outlook?.category?.toLowerCase() === 'below average') {
                return this.belowAverageImage
            }
            if (this.jobOutlook.outlook?.category?.toLowerCase() === 'bright') {
                return this.aboveAverageImage
            }
            if (this.jobOutlook.outlook?.category?.toLowerCase() === 'average') {
                return this.averageImage
            }
        },
        outlookDescription() {
            const categoryMap = {
                'below average': { keyword: 'less likely', color: '#286ABE' },
                'bright': { keyword: 'very likely', color: '#EC833A' },
                'average': { keyword: 'likely', color: '#007A6B' },
            };

            const category = this.jobOutlook.outlook?.category?.toLowerCase();
            const description = this.jobOutlook.outlook?.description;

            if (category && categoryMap[category] && description?.includes(categoryMap[category].keyword)) {
                const coloredText = `<span style="color: ${categoryMap[category].color}; font-weight: bold;font-size: large">${categoryMap[category].keyword}</span>`;
                return description.replace(categoryMap[category].keyword, coloredText);
            }

            return description;
        },
        outlookAltDescription() {
            return this.jobOutlook?.outlook?.description;
        }
    },
    methods: {

    }
}
</script>

<style scoped>
.centered-content {
    text-align: center;
}

.data-average,
.data-average>p {
    color: rgb(0, 200, 220);
    text-align: center;
    font-size: x-large;
    cursor: pointer;
    text-decoration: underline;
}

.data-below-average,
.data-below-average>p {
    font-size: 1.75rem;
    cursor: pointer;
    text-decoration: underline;
}

.data-above-average,
.data-above-average>p {
    font-size: 1.75rem;
    cursor: pointer;
    text-decoration: underline;
}

.outlook-category {
    text-align: center;
    font-size: x-large;
    color: #14223C;
    font-weight: 900;

}

.outlook-description {
    font-size: large;
    font-weight: 100;
}

.outlook-chart {
    margin-top: 3rem;
}

.job-outlook-container {
    padding: .5rem;
}
</style>